import i18nextHttpBackend from 'i18next-http-backend';
const FALLBACK_LNG = 'en';
const i18nextCore = (i18next, locale, baseUrl, cb) => {
    return i18next.use(i18nextHttpBackend).init({
        lng: locale,
        fallbackLng: FALLBACK_LNG,
        keySeparator: '$',
        interpolation: {
            escapeValue: false,
        },
        backend: {
            loadPath: `${baseUrl}assets/translations/messages_{{lng}}.json`,
            crossDomain: true,
        },
    }, cb);
};
const i18n = ({ locale, baseUrl, i18next, }) => {
    return new Promise((resolve, reject) => {
        const i18nInstance = i18nextCore(i18next, locale, baseUrl, (err, t) => {
            return err ? reject(err) : resolve({ t, i18nInstance });
        });
    });
};
export class Translations {
    constructor() {
        this.init = (i18next, locale, baseUrl) => {
            if (this._t) {
                return;
            }
            if (!i18next) {
                return (this._t = (key) => key);
            }
            return i18n({ i18next, locale, baseUrl })
                .catch(() => i18n({ i18next, locale: FALLBACK_LNG, baseUrl }))
                .catch(() => ({ t: (key) => key }))
                .then(({ t }) => {
                this._t = t;
            });
        };
        this.t = (key, options = {}) => {
            if (!this._t) {
                throw new Error('Translation service was not initialized yet!');
            }
            return this._t(key, options);
        };
    }
}
export const TranslationsInstance = new Translations();
//# sourceMappingURL=i18n.js.map